/**
 * The body-level div the Concierge remote portals its overlays into (cart sheet, user menu,
 * weight select). Cross-repo contract with getConciergePortalContainer in dutchie-cf-agents
 * (workers/consumer-client/src/ui/concierge-portal-container.ts): the remote reuses the first
 * [data-concierge-portal] element, and scopes its Tailwind utilities to [data-concierge-root].
 * Either side may create it first, so both create it with both attributes.
 */
export function getConciergePortalContainer(): HTMLElement {
  const existing = document.querySelector<HTMLElement>('[data-concierge-portal]');
  if (existing) {
    return existing;
  }
  const container = document.createElement('div');
  container.setAttribute('data-concierge-root', '');
  container.setAttribute('data-concierge-portal', '');
  document.body.appendChild(container);
  return container;
}
